import { Action } from '@ngrx/store';
import { BusinessData, ManageBusinessData } from '@app/api/models/api-models';

export enum BusinessActionTypes {
  GET_BUSINESS_UNITS = '[Get Business Units Attempt] Get All Business Units',
  GET_BUSINESS_UNITS_SUCCESS = '[Get Business Units Success] Get All Business Units Success',
  GET_BUSINESS_UNITS_FAILURE = '[Get Business Units Failure] Get All Business Units Failure',

  UPDATE_BUSINESS_ATTEMPT = '[Update Business Unit Attempt] [Update Business Unit Attempt',
  UPDATE_BUSINESS_SUCCESS = '[Update Business Unit Success] Update Business Unit Success',
  UPDATE_BUSINESS__FAILURE = '[Update Business Unit Failure] Update Business Unit Failure',

  GET_ACTIONS = '[Actions] Get Business, User Actions and Upgrade Actions',
  SET_SELECTED_BUSINESS = '[Set selected business] Set selected business after udpate',
}

export class GetBusinessUnitsSuccess implements Action {
  readonly type = BusinessActionTypes.GET_BUSINESS_UNITS_SUCCESS;
  constructor(public payload?: { selectedEstablismentId: string; businessList: BusinessData[] }) {}
}

export class GetBusinessUnitsFailure implements Action {
  readonly type = BusinessActionTypes.GET_BUSINESS_UNITS_FAILURE;
  constructor(public payload?: any) {}
}

export class GetBusinessUnitsAttempt implements Action {
  readonly type = BusinessActionTypes.GET_BUSINESS_UNITS;
}

export class UpdateBusinessAttempt implements Action {
  readonly type = BusinessActionTypes.UPDATE_BUSINESS_ATTEMPT;
  constructor(public request: ManageBusinessData) {}
}

export class SetSelectedBusiness implements Action {
  readonly type = BusinessActionTypes.SET_SELECTED_BUSINESS;
  constructor(public businessData: BusinessData) {}
}

export class UpdateBusinessSuccess implements Action {
  readonly type = BusinessActionTypes.UPDATE_BUSINESS_SUCCESS;
}

export class UpdateBusinessFailure implements Action {
  readonly type = BusinessActionTypes.UPDATE_BUSINESS__FAILURE;
}

export class GetActions implements Action {
  readonly type = BusinessActionTypes.GET_ACTIONS;
  constructor(public payload?: { selectedEstablismentId: string; businessList: BusinessData[]; businessUnitActions; userActions; upgradeActions }) {}
}

export type BusinessActions =
  | GetBusinessUnitsAttempt
  | GetBusinessUnitsSuccess
  | GetBusinessUnitsFailure
  | UpdateBusinessAttempt
  | UpdateBusinessSuccess
  | UpdateBusinessFailure
  | GetActions
  | SetSelectedBusiness;
